import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-taxmaster",
  templateUrl: "./taxmaster.component.html"
})
export class TaxmasterComponent implements OnInit {
  searchlist: boolean = true;
  rejected = 2;
  combo_details: any = [];
  offSubmit = false;
  minRemark = false;
  taxValueNotNumeric1 = false;
  taxValueZero1 = false;
  taxValuePercentage1 = false;
  taxNameExceedLength1 = false;
  taxNameMinLength1 = false;
  taxNameNotAlphabet1 = false;
  onlyspaces1 = false;
  onlyspaces = false;
  updateApprove = false;
  aprvbtn = false;
  isApproved = false;
  showList: boolean = false;
  nameExist: boolean = false;
  taxPValueNotNumeric: boolean = false;
  notValidPercentage: boolean = false;
  taxValueFixed: boolean = false;
  taxValuePercentage: boolean = false;
  searchresult = false;
  taxNameMinLength = false;
  taxNameExceedLength = false;
  taxNameNotAlphabet: boolean = false;
  approveStatus;
  taxDescriptionMinLength = false;
  taxDescriptionExceedLength = false;

  taxValueNotNumeric: boolean = false;
  taxValueZero: boolean = false;

  taxValueNotPercentage: boolean = false;

  searchResults: boolean = false;

  viewTitle: string = "Tax Master";
  insertDataTitle: string = "Tax Master";
  screentitle: string = "Tax Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_tax";
  childtables = [];
  filters = [];
  parent_table_ID = "TAX_ID";
  child_table_ID = "fun_id";
  Parent_result_ID = "";
  formData: any = [];
  TAX_NAME = "TAX_NAME";
  TAX_DESCRIPTION = "TAX_DESCRIPTION";
  TAX_VALUE_FIXED = "TAX_VALUE_FIXED";
  TAX_VALUE_PERCENTAGE = "TAX_VALUE_PERCENTAGE";
  TAX_VALUE = "TAX_VALUE";
  FIXED_OR_PERCENTAGE = "FIXED_OR_PERCENTAGE";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  onlyspacesindesc = false;
  dbFields = [
    this.TAX_NAME,
    this.TAX_DESCRIPTION,
    this.TAX_VALUE,
    this.FIXED_OR_PERCENTAGE,
    "STATUS"
  ];

  dbFieldss = [
    this.TAX_NAME,
    this.TAX_DESCRIPTION,
    this.TAX_VALUE,
    this.FIXED_OR_PERCENTAGE
  ];
  dbFieldsChild = [this.parent_table_ID, this.child_table_ID];
  searchitem = " ";
  searchColumn = " ";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  fid = "";
  RAC_VIEW = "";
  uid = "";
  roleID = "";
  checkbox_details: any = [];
  checkboxId: any = [];
  role_search_details: any = [];
  role_screen_details: any = [];
  tax_screen_details: any = [];
  tax_search_details: any = [];
  serachtabledata: any = [];
  serachTableInfo: any = [];
  aprove_details: any = [];
  data: any = [];
  status: any = {};
  p: number = 1;
  loader: any = false;
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
 
  constructor(
    private vernostService: VernostServiceService,
    private commonService : CommonService
    ) {}

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.fid = localStorage.getItem("fid");
    this.roleID = localStorage.getItem("roleID");
    var rollArray_tax = {
      funId: this.fid,
      roleID: this.roleID
    };
    this.addCombo("mst_tax", "TAX_NAME");
    this.vernostService.checkFunAccess(rollArray_tax).subscribe(response => {
      console.log(JSON.stringify(response[0].addinfo));
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.tax_screen_details = {
      TAX_NAME: "",
      TAX_DESCRIPTION: "",
      TAX_VALUE_FIXED: "",
      TAX_VALUE_PERCENTAGE: "",
      TAX_VALUE: "",
      FIXED_OR_PERCENTAGE: ""
    };
    this.tax_search_details = {
      TAX_NAME: "0",
      TAX_DESCRIPTION: "",
      TAX_VALUE_FIXED: "",
      TAX_VALUE_PERCENTAGE: ""
    };
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    var arrayTaxMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayTaxMaster).subscribe(resp => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(resp[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  changeName() {
    // alert(this.Parent_result_ID);
    let dataTaxMaster = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "TAX_ID"
    };

    this.vernostService.getSTATUS(dataTaxMaster).subscribe(resp => {
      // this.approveStatus = 0;
      // this.searchData

      this.approveStatus = resp[0].status;
      if (this.isApproved && 
        this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus() {
    if (this.actionmode == "Edit") {
      var data_tax = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(data_tax).subscribe(response => {
        this.isApproved = false;
      });
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } 
    else if (status == 0) {
      status = 1;
    }

    var data_request = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "TAX_ID",
      status: status
    };

    this.vernostService.changeSTATUS(data_request).subscribe(response => {
      this.searchData();
    });
  }*/

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'tax-master');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();
    //console.log(MODIFIED_TIME);
    var dbFieldTaxMaster = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataTaxMaster = [
      status,
      this.aprove_details.APPROVAL_REMARKS,
      this.uid,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldTaxMaster,
      parent_table: this.parent_table,
      formData: formDataTaxMaster,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.aproveReject(array).subscribe(response => {
      this.aprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        // this.searchForm();
        //this.searchData();
        this.rejected = 2;
      } else {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
        this.aprvbtn = false;
      }
    });
    if (this.actionmode == "Edit") {
      console.log("@@@@@@@@@");
      this.submitdata();
    }
    this.searchData();
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

  addForm() {
    this.rejected = 0;
    this.addCombo("mst_tax", "TAX_NAME");
    this.taxValueNotNumeric1 = false;
    this.taxNameNotAlphabet1 = false;
    this.nameExist = false;
    this.taxNameMinLength = false;
    this.taxNameExceedLength = false;
    this.taxNameNotAlphabet = false;
    this.taxDescriptionMinLength = false;
    this.taxDescriptionExceedLength = false;
    this.taxValueNotNumeric = false;
    this.taxValueZero = false;
    this.taxPValueNotNumeric = false;
    this.notValidPercentage = false;
    this.nameExist = false;
    this.taxValueFixed = false;
    this.taxValuePercentage = false;
    this.tax_search_details = {
      TAX_NAME: "0",
      TAX_DESCRIPTION: "",
      TAX_VALUE_FIXED: "",
      TAX_VALUE_PERCENTAGE: ""
    };
    this.Parent_result_ID = "";
    this.actionmode = "Add";
    this.showList = false;
    this.taxNameNotAlphabet1 = false;
    document.getElementById("errs").innerHTML = "";
  }
  searchForm() {
    this.rejected = 0;
    this.addCombo("mst_tax", "TAX_NAME");
    if (this.actionmode != "Edit") {
      // this.searchData();
    } else {
      this.tax_search_details.TAX_NAME = "0";
      this.tax_search_details.TAX_VALUE_FIXED = "";
      this.searchresult = false;
    }

    this.taxNameMinLength = false;
    this.taxNameExceedLength = false;
    this.taxNameNotAlphabet = false;
    this.taxDescriptionMinLength = false;
    this.taxDescriptionExceedLength = false;
    this.taxValueNotNumeric = false;
    this.taxValueZero = false;
    this.taxPValueNotNumeric = false;
    this.notValidPercentage = false;
    this.taxValueFixed = false;
    this.taxValuePercentage = false;
    this.taxValueNotNumeric1 = false;
    this.taxNameNotAlphabet1 = false;
    this.nameExist = false;
    this.tax_screen_details = {
      TAX_NAME: "",
      TAX_DESCRIPTION: "",
      TAX_VALUE_FIXED: "",
      TAX_VALUE_PERCENTAGE: ""
    };
    this.actionmode = "Search";

    document.getElementById("errs").innerHTML = "";

    this.taxNameNotAlphabet1 = false;
    //this.searchData();
  }

  addCheckbox(childtable) {
    var array = {
      childtable: childtable
    };

    this.vernostService.getCheckBoxData(array).subscribe(response => {
      if (response[0].status == this.childtables[0]) {
        this.checkbox_details = response[0].result;
        console.log("checkbox data" + JSON.stringify(this.checkbox_details));
      }
    });
  }
  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.actionmode = "Edit";
      this.updateApprove = true;
      this.showList = false;
      if (status == 0 && 
        approvestatus == 0) {
        this.isApproved = false;
      }

      if (approvestatus == 1) {
        this.isApproved = true;
      }
    }
    this.Parent_result_ID = formData;

    var array_tax = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };

    this.vernostService.getData(array_tax).subscribe(response => {
      this.tax_screen_details = {
        TAX_NAME: response[0].result[0].TAX_NAME,
        TAX_DESCRIPTION: response[0].result[0].TAX_DESCRIPTION
      };

      this.approveStatus = response[0].result[0].STATUS;

      var FIXED_OR_PERCENTAGE = response[0].result[0].FIXED_OR_PERCENTAGE;
      var TAX_VALUE = response[0].result[0].TAX_VALUE;
      console.log(FIXED_OR_PERCENTAGE);
      console.log(TAX_VALUE);
      if (FIXED_OR_PERCENTAGE == 0) {
        this.tax_screen_details.TAX_VALUE_FIXED = TAX_VALUE;
      } else {
        this.tax_screen_details.TAX_VALUE_PERCENTAGE = TAX_VALUE;
      }

      this.serachTableInfo = response[0].result;
      // if (toggle == "1") {
      //   this.showList = true;
      //   this.actionmode = "Add";
      // }
      if (toggle == "1") {
        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitdata() {
    this.offSubmit = false;
    // this.tax_screen_details.TAX_VALUE_FIXED;
    // this.tax_screen_details.TAX_VALUE_PERCENTAGE;
    // if (this.tax_screen_details.TAX_VALUE_FIXED != "") {
    //   this.tax_screen_details.TAX_VALUE = this.tax_screen_details.TAX_VALUE_FIXED;
    //   this.tax_screen_details.FIXED_OR_PERCENTAGE = 0;
    // }
    // if (this.tax_screen_details.TAX_VALUE_PERCENTAGE != "") {
    //   this.tax_screen_details.TAX_VALUE = this.tax_screen_details.TAX_VALUE_PERCENTAGE;
    //   this.tax_screen_details.FIXED_OR_PERCENTAGE = 1;
    // }
    if (
      this.tax_screen_details.TAX_VALUE_FIXED == "" ||
      this.tax_screen_details.TAX_VALUE_FIXED == undefined
    ) {
      this.tax_screen_details.TAX_VALUE = this.tax_screen_details.TAX_VALUE_PERCENTAGE;
      this.tax_screen_details.FIXED_OR_PERCENTAGE = 1;
    }
    if (
      this.tax_screen_details.TAX_VALUE_PERCENTAGE == "" ||
      this.tax_screen_details.TAX_VALUE_PERCENTAGE == undefined
    ) {
      this.tax_screen_details.TAX_VALUE = this.tax_screen_details.TAX_VALUE_FIXED;
      this.tax_screen_details.FIXED_OR_PERCENTAGE = 0;
    }

    if (this.actionmode != "Edit") {
      this.checkNames();
    } else {
      this.nameExist = false;
    }
    if (this.nameExist) {
      //  alert("name availabe");
    } else {
      var TAX_NAME = this.tax_screen_details.TAX_NAME;
      var TAX_DESCRIPTION = this.tax_screen_details.TAX_DESCRIPTION;

      if (TAX_NAME != "" && TAX_DESCRIPTION != "") {
        if (
          this.tax_screen_details.TAX_VALUE_FIXED == "" &&
          this.tax_screen_details.TAX_VALUE_PERCENTAGE == ""
        ) {
          console.log("hello1");
          document.getElementById("errs").innerHTML = "Please fill all data";
        } else {
          this.formData = [
            this.tax_screen_details.TAX_NAME,
            this.tax_screen_details.TAX_DESCRIPTION,
            this.tax_screen_details.TAX_VALUE,
            this.tax_screen_details.FIXED_OR_PERCENTAGE
          ];

          if (this.Parent_result_ID != "") {
            var array = {
              parent_table: this.parent_table,
              dbFields: this.dbFieldss,
              parent_table_ID: this.parent_table_ID,
              formData: this.formData,
              formdataId: this.Parent_result_ID,
              USER_ID: this.uid
            };
            this.vernostService.editData(array).subscribe(response => {
              // alert(JSON.stringify(response[0].status));
              // this.searchForm();

              document.getElementById("errs").innerHTML =
                "Record Updated Successfully";
              // setTimeout(() => {
              //   document.getElementById("errs").innerHTML = "";
              //   document.getElementById("errs").style.background = "#ebccd1";
              //   document.getElementById("errs").style.color = "#a94442";
              // }, 1000);
            });
          }
          if (this.Parent_result_ID == "") {
            document.getElementById("errs").innerHTML = "";
            console.log("form Data===========>", this.formData);
            var Data = {
              parent_table: this.parent_table,
              dbFields: this.dbFieldss,
              formData: this.formData,
              USER_ID: this.uid,
              PAGENAME: "TAX"
            };
            this.vernostService.insertData(Data).subscribe(response => {
              console.log(JSON.stringify(response[0].message));

              if (JSON.stringify(response[0].message == "Data inserted")) {
                document.getElementById("errs").innerHTML =
                  "Record Created Successfully";
                // setTimeout(() => {
                //   document.getElementById("errs").innerHTML = "";
                //   document.getElementById("errs").style.background = "#ebccd1";
                //   document.getElementById("errs").style.color = "#a94442";
                // }, 1000);
                this.showFormData(response[0].addinfo, 3, 1, 1);
              }
            });
          }
        }
      } else {
        // console.log("please fill all forms details");
        document.getElementById("errs").innerHTML = "please fill all data";
      }
    }
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;
    // console.log("this.screen_details", this.search_details);

    var field1 = this.tax_search_details.TAX_NAME;

    var field2 = this.tax_search_details.TAX_VALUE_FIXED;

    if (
      (field1 == "" || field1 == undefined || field1 == "0") &&
      (field2 == "" || field2 == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined && field1 != "0") {
        searchitem.push(field1);
        searchColumn.push("TAX_NAME");
      }
      if (field2 != "" && field1 != undefined) {
        searchitem.push(field2);
        searchColumn.push("TAX_VALUE");
      }

      console.log(this.parent_table);
      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchRecord(Data).subscribe(response => {
        if (response.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;
          console.log("resule=" + JSON.stringify(response));
          this.searchresult = true;
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  checkTaxName(data) {
    this.validateTaxNames(data);
    this.checkNames();
  }
  validateTaxNames(data) {
    if (data.length == 0) {
      this.taxNameNotAlphabet = false;
      this.taxNameMinLength = false;
      this.onlyspaces = false;
    } else {
      var space_reg = /^[ ]+$/;
      var onlyspace = space_reg.test(data);
      if (onlyspace) {
        this.onlyspaces = true;
      }

      if (data.length < 2) {
        this.taxNameMinLength = true;
        // this.taxNameNotAlphabet = false;
      } else {
        this.taxNameMinLength = false;
      }
    }
  }

  checkTaxName1(data) {
    if (data.length == 0) {
      this.taxNameNotAlphabet1 = false;
      this.taxNameMinLength1 = false;
      this.onlyspaces1 = false;
    } else {
      var space_reg = /^[ ]+$/;
      var onlyspace = space_reg.test(data);
      if (onlyspace) {
        this.onlyspaces1 = true;
      }

      if (data.length < 2) {
        this.taxNameMinLength1 = true;
        // this.taxNameNotAlphabet = false;
      } else {
        this.taxNameMinLength1 = false;
      }
    }
  }

  checkTaxNameLength1(data) {
    this.taxNameExceedLength1 = false;
    this.taxNameMinLength1 = false;
    this.taxNameNotAlphabet1 = false;
    this.onlyspaces1 = false;

    console.log(data);
    console.log(data.length);

    if (data.length == 0) {
      this.taxNameMinLength1 = false;
      this.taxNameNotAlphabet1 = false;
      console.log("hii");
    } else {
      console.log("byy");
      var regx = /^[A-Za-z\s]+$/;
      var checkAlphabet = regx.test(data);
      if (!checkAlphabet) {
        this.taxNameNotAlphabet1 = true;
      } else {
        this.taxNameNotAlphabet1 = false;
      }
    }

    if (data.length > 45) {
      this.taxNameExceedLength1 = true;
      this.taxNameMinLength1 = false;
    } else {
      this.taxNameExceedLength1 = false;
    }
  }

  checkTaxNameLength(data) {
    document.getElementById("errs").innerHTML = "";
    this.taxNameExceedLength = false;
    this.taxNameMinLength = false;
    this.taxNameNotAlphabet = false;
    this.nameExist = false;
    this.onlyspaces = false;
    console.log(data);
    console.log(data.length);
    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }

    if (data.length == 0) {
      this.taxNameMinLength = false;
      this.taxNameNotAlphabet = false;
      console.log("hii");
    } else {
      console.log("byy");
      var regx = /^[A-Za-z\s]+$/;

      //      var regx = /^[a-zA-Z0-9"!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"\s]{0,100}$/;

      var checkAlphabet = regx.test(data);
      if (!checkAlphabet) {
        this.taxNameNotAlphabet = true;
      } else {
        this.taxNameNotAlphabet = false;
      }
    }

    if (data.length > 45) {
      this.taxNameExceedLength = true;
      this.taxNameMinLength = false;
    } else {
      this.taxNameExceedLength = false;
    }
  }

  checkTaxDescription(data) {
    this.validateTaxDescription(data);
  }
  validateTaxDescription(data) {
    if (data.length == 0) {
      this.taxDescriptionMinLength = false;
      this.onlyspacesindesc = false;
    } else {
      var space_reg = /^[ ]+$/;
      var onlyspace = space_reg.test(data);
      if (onlyspace) {
        this.onlyspacesindesc = true;
      }
      if (data.length < 2) {
        this.taxDescriptionMinLength = true;
      } else {
        this.taxDescriptionMinLength = false;
      }
    }
  }
  checkTaxDescriptionLength(data) {
    document.getElementById("errs").innerHTML = "";
    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }
    this.taxDescriptionExceedLength = false;
    this.taxDescriptionMinLength = false;
    this.onlyspacesindesc = false;
    console.log(data);

    if (data.length > 45) {
      this.taxDescriptionExceedLength = true;
      this.taxDescriptionMinLength = false;
    } else {
      this.taxDescriptionExceedLength = false;
    }
  }

  checkTaxValue(data) {
    document.getElementById("errs").innerHTML = "";
    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }
    this.checkTaxValueFixed(data);
    console.log(data);
    this.taxValueNotNumeric = false;
    if (data == "") {
      this.taxValueNotNumeric = false;
    }
  }

  checkTaxValue1(data) {
    this.checkTaxValueFixed1(data);
    console.log(data);
    this.taxValueNotNumeric1 = false;
    if (data == "") {
      this.taxValueNotNumeric1 = false;
    } else {
      var regx = /^[0-9]\d*(\.\d+)?$/;
      var checkAlphabet = regx.test(data);

      if (!checkAlphabet) {
        this.taxValueNotNumeric1 = true;
      } else {
        this.taxValueNotNumeric1 = false;
      }
    }
  }

  clerDisabled() {
    this.taxValueNotNumeric1 = false;
  }
  checkTaxValueZero(data) {
    this.taxValueZero = false;
    if (data == "") {
      this.taxValueZero = false;
    } else {
      var regx = /^[0-9]\d*(\.\d+)?$/;
      var checkAlphabet = regx.test(data);

      if (!checkAlphabet) {
        this.taxValueNotNumeric = true;
      } else {
        this.taxValueNotNumeric = false;
      }
    }
  }

  checkTaxValuePerc(data) {
    document.getElementById("errs").innerHTML = "";
    this.checkTaxValuePercentage(data);
    console.log(data);
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      // this.RAC_APROVE = "1";
    }

    this.taxPValueNotNumeric = false;
    this.notValidPercentage = false;

    var regx1 = /^[0-9.]*$/;
    var checkNumberAndDot = regx1.test(data);
    if (checkNumberAndDot == true) {
      this.taxPValueNotNumeric = false;
      // var regx = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
      // var checkPercentage = regx.test(data);
      var checkPercentage =true;
      if (checkPercentage == true) {
        this.notValidPercentage = false;
      } else {
        this.notValidPercentage = true;
      }
    } else {
      this.taxPValueNotNumeric = true;
    }
  }

  submitData1() {
    ///  this.loader = true;

    var TAX_NAME = this.tax_screen_details.TAX_NAME;
    var TAX_DESCRIPTION = this.tax_screen_details.TAX_DESCRIPTION;

    if (
      TAX_NAME != "" &&
      TAX_DESCRIPTION != "" &&
      TAX_NAME != undefined &&
      TAX_DESCRIPTION != undefined &&
      TAX_NAME.length !== 0 &&
      TAX_DESCRIPTION.length !== 0
    ) {
      if (
        this.tax_screen_details.TAX_VALUE_FIXED == "" &&
        this.tax_screen_details.TAX_VALUE_PERCENTAGE == ""
      ) {
        document.getElementById("errs").innerHTML = "please fill all data";
      } else {
        if (this.actionmode != "Edit") {
          this.offSubmit = true;
          this.checkNames();
        } else {
          this.submitdata();
        }
      }
    } else {
      document.getElementById("errs").innerHTML = "please fill all data";
    }
  }
  checkNames() {
    if (
      this.tax_screen_details.TAX_NAME != "" &&
      this.tax_screen_details.TAX_NAME != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "TAX_NAME",
          dbFieldName: this.tax_screen_details.TAX_NAME,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist = true;
          }
        });
      }
    }
  }

  checkTaxValueFixed(data) {
    console.log(data);
    if (data != "") {
      this.taxValuePercentage = true;
      this.tax_screen_details.TAX_VALUE_PERCENTAGE = "";
    } else {
      this.taxValuePercentage = false;
    }
  }

  checkTaxValueFixed1(data) {
    console.log(data);
    if (data != "") {
      this.taxValuePercentage1 = true;
      this.tax_screen_details.TAX_VALUE_PERCENTAGE1 = "";
    } else {
      this.taxValuePercentage1 = false;
    }
  }

  checkTaxValuePercentage(data) {
  
    if (data != "") {
      this.taxValueFixed = true;
      this.tax_screen_details.TAX_VALUE_FIXED = "";
    } 
    else {
      this.taxValueFixed = false;
    }
  }


  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }


  checkRemarkLength(params) {
    if (params.length < 3) {
      this.minRemark = true;
    } 
    else {
      this.minRemark = false;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || 
      val == "" || 
      val.length < 3) {
      this.aprvbtn = false;
    } 
    else {
      this.aprvbtn = true;
    }
  }

  addCombo(childtable, dbField) {
    var array_combo = {
      childtable: childtable,
      dbField: dbField
    };
    this.vernostService.getComboData(array_combo).subscribe(response => {
      this.combo_details = response[0].result;
    });
  }
}
